import { StaticImage } from 'gatsby-plugin-image';
import React, { MouseEvent } from 'react';
import { openIntercom } from '../util/Intercom';
import { trackLink } from '../util/Segment';
import './Footer.css';

interface FooterProps {}
const Footer = () => {
    const handleIntercomClick = (e: MouseEvent) => {
        e.preventDefault();
        openIntercom();
    };

    return (
        <footer className="Footer">
            <div className="wrapper">
                <div className="FooterRow">
                    <div>
                        <h4>Available on</h4>
                        <a
                            className="inline-block mr-4"
                            href="https://play.google.com/store/apps/details?id=com.fieldmargin"
                            onClick={trackLink('Footer Google play button clicked')}
                        >
                            <span className="sr-only">Google Play Store</span>
                            <StaticImage
                                src="../images/android.png"
                                alt="Download on Play Store"
                                layout="fixed"
                                height={34}
                                aria-hidden
                            />
                        </a>

                        <a
                            className="inline-block mr-4"
                            href="https://itunes.apple.com/gb/app/fieldmargin-your-farm-in-your-pocket/id1096607801"
                            onClick={trackLink('Footer App store button clicked')}
                        >
                            <span className="sr-only">Apple App Store</span>
                            <StaticImage
                                src="../images/ios.png"
                                alt="Download on the App Store"
                                layout="fixed"
                                height={34}
                                aria-hidden
                            />
                        </a>

                        <a
                            className="inline-block"
                            href="https://notes.fieldmargin.com"
                            onClick={trackLink('Footer web app button clicked')}
                        >
                            <span className="sr-only">The web</span>
                            <StaticImage
                                src="../images/web.png"
                                alt="Try our web app"
                                layout="fixed"
                                height={34}
                                aria-hidden
                            />
                        </a>
                    </div>
                    <div>
                        <h4>Need help?</h4>
                        <p>
                            <a href="http://support.fieldmargin.com" onClick={handleIntercomClick}>
                                Send us a message
                            </a>
                            <br />
                            Call us on (+44) 203 289 4200
                            <br />
                            Email{' '}
                            <a href="mailto:support@fieldmargin.com">support@fieldmargin.com</a>
                            <br />
                            Read our{' '}
                            <a href="http://support.fieldmargin.com">support documentation</a>
                        </p>
                    </div>
                    <div>
                        <h4>Office</h4>
                        <p>
                            Field Margin Ltd.
                            <br />
                            6 Ritherdon Road
                            <br />
                            London SW17 8QD
                        </p>
                    </div>
                </div>
                <div className="FooterRow">
                    <div>
                        <a
                            href="https://www.facebook.com/fieldmargin/"
                            className="inline-block mr-4"
                        >
                            <span className="sr-only">Facebook</span>
                            <StaticImage
                                src="../images/facebook.png"
                                alt="Facebook F icon"
                                layout="fixed"
                                height={20}
                                aria-hidden
                            />
                        </a>

                        <a href="https://twitter.com/fieldmargin/" className="inline-block mr-4">
                            <span className="sr-only">Twitter</span>
                            <StaticImage
                                src="../images/twitter.png"
                                alt="Twitter bird logo"
                                layout="fixed"
                                height={20}
                                aria-hidden
                            />
                        </a>

                        <a
                            href="https://www.linkedin.com/company/fieldmargin"
                            className="inline-block"
                        >
                            <span className="sr-only">LinkedIn</span>
                            <StaticImage
                                src="../images/linkedin.png"
                                alt="LinkedIn logo"
                                layout="fixed"
                                height={20}
                                aria-hidden
                            />
                        </a>
                    </div>
                    <div>
                        <p>
                            <a href="https://www.fieldmargin.com/terms-and-privacy-policy.html">
                                Terms &amp; Conditions and Privacy Policy
                            </a>
                        </p>
                    </div>
                    <div>
                        <p>&copy; Field Margin Ltd. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
